import { orderXClient } from '@/service/client'
import type { DataPayload, EtfFlowSeries, EtfFundFlowsRequest } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

// ENG-868 — crypto-ETF fund flows (ETF Global via Massive.com). A single read-only
// pull endpoint: the feed is ingested once a day, so there is no MessageSubject and
// no /ws subscription to pair with this.

export async function fetchEtfFundFlows(
  params: EtfFundFlowsRequest,
  signal?: AbortSignal
): Promise<EtfFlowSeries> {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      {
        etfFundFlows: params,
      },
      {
        headers: {
          'X-Decode-Key': 'datapayload',
        },
        signal,
      }
    )

    // Only a missing oneof arm is a failure. An EMPTY `points` array is a perfectly
    // good response — it is what an asset returns before its first published day,
    // and what every asset returns on an environment with no vendor API key — so it
    // must reach the caller as success and render as an empty state, not an error.
    const series = data.etfFlowSeries
    if (!series) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch ETF fund flows',
      } satisfies ErrorResponse)
    }

    return series
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
